import Vue from 'vue';
import { i18n } from '@/plugins/vuei18n';
import {
  USER_REQUEST,
  USER_ERROR,
  USER_SUCCESS,
  SET_EVENT_CONTACTS,
  FETCH_USER_CONTACTS_REQUEST,
  FETCH_USER_CONTACTS_SUCCESS,
  FETCH_USER_CONTACTS_ERROR,
  ADD_EVENT_SELECTED_CONTACTS_SUCCESS,
  ADD_EVENT_SELECTED_CONTACTS_ERROR,
  DELETE_EVENT_SELECTED_CONTACTS_SUCCESS,
  DELETE_EVENT_SELECTED_CONTACTS_ERROR,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  SEARCH_CONTACT_REQUEST,
  SEARCH_CONTACT_SUCCESS,
  SEARCH_CONTACT_UNREGISTERED,
  SEARCH_CONTACT_ERROR,
  CLEAR_SEARCH_CONTACT,
  ADD_USER_CONTACT_REQUEST,
  ADD_USER_CONTACT_SUCCESS,
  ADD_USER_CONTACT_ERROR,
  SET_FINAL_EVENT_SELECTED_CONTACTS,
  DELETE_FINAL_EVENT_SELECTED_CONTACTS,
  SET_EVENT_SELECTED_CONTACTS,
  ADD_USER_SELECTED_CONTACTS,
  SET_USER_SELECTED_CONTACTS,
  DELETE_USER_SELECTED_CONTACTS,
  SET_FINAL_USER_SELECTED_CONTACTS,
  DELETE_FINAL_USER_SELECTED_CONTACTS,
  CREATE_USER_CONTACT_REQUEST,
  CREATE_USER_CONTACT_SUCCESS,
  CREATE_USER_CONTACT_ERROR,
  DELETE_USER_CONTACT_ERROR,
  DELETE_USER_CONTACT_SUCCESS,
  DELETE_USER_CONTACT_REQUEST,
  RESET_USER_DATA,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_ERROR,
} from './types';
// import { AUTH_LOGOUT } from '../auth/types';
import { resetUser } from './userResettingFunc';

export const getters = {
  getProfile: (state) => state.user,
  isProfileLoaded: (state) => !!state.user.fullName,
  isUserInfoFilled: (state) => {
    const { user } = state;
    return !!(user && user.user && user.full_name && user.avatar_url);
  },
  eventContactBook: (state) => {
    const user = { ...state.user };
    user.full_name = i18n.t('CP.me');
    user.uid = user.user;
    if (Array.isArray(state.eventContacts)) {
      return [user, ...state.eventContacts.filter((contact) => contact.uid !== user.user)];
    }
    return [user];
  },
  userContactBook: (state) => {
    const user = { ...state.user };
    user.full_name = i18n.t('CP.me');
    user.uid = user.user;
    if (Array.isArray(state.userContacts)) {
      return [user, ...state.userContacts.filter((contact) => contact.uid !== user.user)];
    }
    return [user];
  },
  // eslint-disable-next-line no-shadow
  eventUnselectedContacts: (state, getters) => getters.eventContactBook
    .filter((contact) => !state.eventSelectedContacts
      .find((selected) => contact.uid === selected.uid)),
  // eslint-disable-next-line no-shadow
  userUnselectedContacts: (state, getters) => (
    getters.userContactBook
      .filter((contact) => !state.userSelectedContacts
        .find((selected) => contact.uid === selected.uid))
  ),
};

export const mutations = {
  [USER_REQUEST]: (state) => {
    state.userStatus = 'loading';
  },
  [USER_SUCCESS]: (state, resp) => {
    state.userStatus = 'success';
    // eslint-disable-next-line no-param-reassign
    if (resp.user) resp.uid = resp.user;
    Vue.set(state, 'user', resp);
  },
  [USER_ERROR]: (state) => {
    state.userStatus = 'error';
  },
  [UPDATE_USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_USER_SUCCESS]: (state, res) => {
    state.status = 'success';
    state.user = res;
  },
  [UPDATE_USER_ERROR]: (state, e) => {
    state.status = 'error';
    state.error = e;
  },

  [CHANGE_PASSWORD_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [CHANGE_PASSWORD_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [CHANGE_PASSWORD_ERROR]: (state, e) => {
    state.status = 'error';
    state.error = e;
  },

  // [AUTH_LOGOUT]: (state) => {
  //   state.user = {};
  //   state.status = '';
  // },
  [SET_EVENT_CONTACTS]: (state, eventContacts) => {
    state.eventContacts = eventContacts;
  },
  [FETCH_USER_CONTACTS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [FETCH_USER_CONTACTS_SUCCESS]: (state, res) => {
    state.status = 'success';
    state.userContacts = res;
  },
  [FETCH_USER_CONTACTS_ERROR]: (state, e) => {
    state.status = 'error';
    state.error = e.message;
  },
  [SEARCH_CONTACT_REQUEST]: (state) => {
    state.searchContactStatus = 'loading';
  },
  [SEARCH_CONTACT_SUCCESS]: (state, res) => {
    state.searchContactStatus = 'success';
    state.searchContact = res;
  },
  [SEARCH_CONTACT_UNREGISTERED]: (state, res) => {
    state.searchContactStatus = 'unregistered';
    state.searchContact = res;
  },
  [SEARCH_CONTACT_ERROR]: (state, e) => {
    state.searchContactStatus = 'error';
    state.searchContactError = e;
  },
  [CLEAR_SEARCH_CONTACT]: (state) => {
    state.searchContact = {};
    state.searchContactStatus = '';
    state.searchContactError = '';
  },
  [ADD_USER_CONTACT_REQUEST]: (state) => {
    state.addUserContactStatus = 'loading';
  },
  [ADD_USER_CONTACT_SUCCESS]: (state, contacts) => {
    state.addUserContactStatus = 'success';
    state.userContacts = contacts;
  },
  [ADD_USER_CONTACT_ERROR]: (state, e) => {
    state.addUserContactStatus = 'error';
    state.error = e;
  },
  [CREATE_USER_CONTACT_REQUEST]: (state) => {
    state.createUserContactStatus = 'loading';
  },
  [CREATE_USER_CONTACT_SUCCESS]: (state, contacts) => {
    state.createUserContactStatus = 'success';
    state.userContacts = contacts;
  },
  [CREATE_USER_CONTACT_ERROR]: (state, e) => {
    state.createUserContactStatus = 'error';
    state.error = e;
  },
  [DELETE_USER_CONTACT_REQUEST]: (state) => {
    state.deleteUserContactStatus = 'loading';
  },
  [DELETE_USER_CONTACT_SUCCESS]: (state, contact) => {
    state.deleteUserContactStatus = 'success';
    state.userContacts.filter((userContact) => userContact.phone !== contact.phone);
  },
  [DELETE_USER_CONTACT_ERROR]: (state, e) => {
    state.deleteUserContactStatus = 'error';
    state.error = e;
  },
  [ADD_EVENT_SELECTED_CONTACTS_SUCCESS]: (state, res) => {
    state.eventSelectedContacts = state.eventSelectedContacts.concat(res);
  },
  [ADD_EVENT_SELECTED_CONTACTS_ERROR]: (state, err) => {
    state.status = err;
  },
  [SET_EVENT_SELECTED_CONTACTS]: (state, contacts) => {
    state.eventSelectedContacts = JSON.parse(JSON.stringify(contacts));
  },
  [ADD_USER_SELECTED_CONTACTS]: (state, contacts) => {
    state.userSelectedContacts = state.userSelectedContacts.concat(contacts);
  },
  [SET_USER_SELECTED_CONTACTS]: (state, contacts) => {
    state.userSelectedContacts = JSON.parse(JSON.stringify(contacts));
  },
  [SET_FINAL_EVENT_SELECTED_CONTACTS]: (state, contacts) => {
    state.finalEventSelectedContacts = JSON.parse(JSON.stringify(contacts));
  },
  [SET_FINAL_USER_SELECTED_CONTACTS]: (state, contacts) => {
    state.finalUserSelectedContacts = JSON.parse(JSON.stringify(contacts));
  },
  [DELETE_FINAL_EVENT_SELECTED_CONTACTS]: (state, contact = null) => {
    if (contact && contact.uid) {
      const index = state.finalEventSelectedContacts
        .findIndex((selected) => selected.uid === contact.uid);
      state.finalEventSelectedContacts.splice(index, 1);
    } else {
      state.finalEventSelectedContacts = [];
    }
  },
  [DELETE_FINAL_USER_SELECTED_CONTACTS]: (state, contact = null) => {
    if (contact && contact.uid) {
      const index = state.finalUserSelectedContacts
        .findIndex((selected) => selected.uid === contact.uid);
      state.finalUserSelectedContacts.splice(index, 1);
    } else {
      state.finalUserSelectedContacts = [];
    }
  },
  [DELETE_USER_SELECTED_CONTACTS]: (state, contact = null) => {
    if (contact && typeof contact.uid !== 'undefined') {
      state.userSelectedContacts = state.userSelectedContacts
        .filter((member) => member.uid !== contact.uid);
    } else {
      state.userSelectedContacts = [];
    }
  },
  [DELETE_EVENT_SELECTED_CONTACTS_SUCCESS]: (state, contact = null) => {
    if (contact && contact.uid) {
      const index = state.eventSelectedContacts
        .findIndex((selected) => selected.uid === contact.uid);
      state.eventSelectedContacts.splice(index, 1);
    } else {
      state.eventSelectedContacts = [];
    }
  },
  [DELETE_EVENT_SELECTED_CONTACTS_ERROR]: (state, err) => {
    state.status = err;
  },
  [RESET_USER_DATA]: (state) => {
    resetUser(state);
  },
  [DELETE_ACCOUNT_REQUEST]: (state) => {
    state.deleteAccountStatus = 'loading';
  },
  [DELETE_ACCOUNT_SUCCESS]: (state) => {
    state.deleteAccountStatus = 'success';
  },
  [DELETE_ACCOUNT_ERROR]: (state, error) => {
    state.deleteAccountStatus = 'error';
    state.deleteAccountError = error;
  },
};

export const state = {
  status: '',
  user: {},
  userStatus: '',
  addUserContactStatus: '',
  createUserContactStatus: '',
  deleteUserContactStatus: '',
  userContacts: [],
  userSelectedContacts: [],
  finalUserSelectedContacts: [],
  eventContacts: [],
  eventSelectedContacts: [],
  finalEventSelectedContacts: [],
  error: '',
  searchContactStatus: '',
  searchContact: {},
  searchContactError: '',
  deleteAccountStatus: '',
  deleteAccountError: '',
};
